/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ApplicationDetails from '../../src/components/Applications/ApplicationDetails.jss.js';
import ApplicationOverview from '../../src/components/Applications/ApplicationOverview.jss.js';
import DlpFlow from '../../src/components/dlp/DlpFlow.jss.js';
import DupFlow from '../../src/components/dup/DupFlow.jss.js';
import Footer from '../../src/components/Footer.jss.js';
import GuidedTour from '../../src/components/GuidedTour/GuidedTour.jss.js';
import ImageBanner from '../../src/components/ImageBanner.jss.js';
import LoginBanner from '../../src/components/LoginBanner.jss.js';
import MyClients from '../../src/components/MyClients.jss.js';
import DlpPolicyDetails from '../../src/components/Policy/DlpPolicyDetails.jss.js';
import PolicyDetails from '../../src/components/Policy/PolicyDetails.jss.js';
import PolicyMutation from '../../src/components/Policy/PolicyMutation.jss.js';
import PolicyOverview from '../../src/components/Policy/PolicyOverview.jss.js';
import PremiumCalculationChoice from '../../src/components/PremiumCalculationChoice.jss.js';
import RichText from '../../src/components/Shared/RichText.jss.js';
import SidebarNavigation from '../../src/components/SidebarNavigation.jss.js';
import Topbar from '../../src/components/Topbar.jss.js';

const components = new Map();
components.set('ApplicationDetails', ApplicationDetails);
components.set('ApplicationOverview', ApplicationOverview);
components.set('DlpFlow', DlpFlow);
components.set('DupFlow', DupFlow);
components.set('Footer', Footer);
components.set('GuidedTour', GuidedTour);
components.set('ImageBanner', ImageBanner);
components.set('LoginBanner', LoginBanner);
components.set('MyClients', MyClients);
components.set('DlpPolicyDetails', DlpPolicyDetails);
components.set('PolicyDetails', PolicyDetails);
components.set('PolicyMutation', PolicyMutation);
components.set('PolicyOverview', PolicyOverview);
components.set('PremiumCalculationChoice', PremiumCalculationChoice);
components.set('RichText', RichText);
components.set('SidebarNavigation', SidebarNavigation);
components.set('Topbar', Topbar);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
